import React from 'react';

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SelectField from '../Molecules/SelectField';
import SingleNextButton from '../Atoms/SingleNextButton';
import YearMonthField from '../Atoms/YearMonthField';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import { setApp, getApp} from '../../index';
import { currencyRegex, zipRegex } from '../../Utils/ValidationPatterns';
import { usStates, ownershipStatuses } from '../../Utils/SelectOptions';

class StepContactInfo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            mailingAddress: false,
            showMonthlyPayment: true
        }
    }

    toggleMailingAddress(event) {
        var flipMailing = this.state.mailingAddress;

        this.setState({
            mailingAddress: !flipMailing
        });
        setApp('mailingCheck', !flipMailing);

        if(!flipMailing === true) {
            if(getApp('saveMailingAddress') !== "") { setApp('mailingAddress', getApp('saveMailingAddress')); }
            if(getApp('saveMailingAddress2') !== "") { setApp('mailingAddress2', getApp('saveMailingAddress2')); }
            if(getApp('saveMailingCity') !== "") { setApp('mailingCity', getApp('saveMailingCity')); }
            if(getApp('saveMailingState') !== "") { setApp('mailingState', getApp('saveMailingState')); }
            if(getApp('saveMailingZipcode') !== "") { setApp('mailingZipcode', getApp('saveMailingZipcode')); }            
        }else {
            setApp('saveMailingAddress', getApp('mailingAddress'));
            setApp('saveMailingAddress2', getApp('mailingAddress2'));
            setApp('saveMailingCity', getApp('mailingCity'));
            setApp('saveMailingState', getApp('mailingState'));
            setApp('saveMailingZipcode', getApp('mailingZipcode'));
            setTimeout(function(){
                setApp('mailingAddress', '');
                setApp('mailingAddress2', '');
                setApp('mailingCity', '');
                setApp('mailingState', '');
                setApp('mailingZipcode', '');                
            }, 100);
        }
    }

    checkLivingSituation(event) {
        var glLivingSit = getApp('ownershipStatus');
        if(glLivingSit === "Rents" || glLivingSit === "Owns") {
            this.setState({"showMonthlyPayment":true});
        }else{
            this.setState({"showMonthlyPayment":false});
        }
    }

    render() {

        let mailing;
        let mailingClass;
        //let mPayment;

        if(this.state.mailingAddress) {
            mailingClass = "remove";
            mailing = (
                <MailingAddress />
            );
        }else if(getApp('mailingCheck') === true) {
            mailingClass = "remove";
            mailing = (
                <MailingAddress />
            );
        }else {
            mailingClass = "add";
            mailing = "";
        }

        var mPaymentRequired = ( <NumberField name="monthlyPayment" prefix="$" pattern={currencyRegex} label="Monthly Payment" required={true}/> );

        var mPaymentOptional = ( <NumberField name="monthlyPayment" prefix="$" pattern={currencyRegex} label="Monthly Payment (optional)" required={false}/> );

        var rFirstName = getApp('fname');
        var firstName = rFirstName.charAt(0).toUpperCase() + rFirstName.slice(1);

        return (

            <StepShell stepID="StepContactInfo"
                friendlyText={`Thanks ${firstName}. Now tell us about where you live.`}
                requestText=""
                progress="35%"
                progressLabel="Address"
                backLink="/loan-application/verification"
            >
                <Form nextLink="/loan-application/work" >

                    <TextField name="address" label="Address" required={true} />
                    <TextField name="address2" label="Address 2" />
                    <TextField name="city" label="City" required={true} />
                    <SelectField options={usStates} required={true} name="state" placeholder="State" labelType="bold" label="Select Your State"
                            />
                    <NumberField name="zipcode" pattern={zipRegex} format="#####" label="ZIP Code" required={true}/>
                    <span className="dropdown-text">Living Situation:</span>
                    
                    <div onChange={this.checkLivingSituation.bind(this)} >
                        <SelectField options={ownershipStatuses} required={true} name="ownershipStatus" placeholder="Select One" label="ownership status" labelType="hidden"
                        />
                    </div>
                    {this.state.showMonthlyPayment ? mPaymentRequired : mPaymentOptional }
                    <span className="dropdown-text">How long have you been at your current residence?</span>
                    <YearMonthField yearsName="yearsAtAddress" yearsLabel="Years" monthsName="monthsAtAddress" monthsLabel="Months" />
                    <div className="loanApp-form-row add-mailing-address">
                        <div className="step-request-text">
                            If you have a different mailing address than your current residence (such as a P.O. Box), <span className={mailingClass} onClick={this.toggleMailingAddress.bind(this)} > a Mailing Address</span>
                        </div>
                        {mailing}
                    </div>
                    <SingleNextButton nextBtnTxt="next" />
                </Form>
                
            </StepShell>
        )
    }
}

// This component is used when applicant has mailing address other than using residential address
class MailingAddress extends React.Component {
    render() {
        return (
            <div className="mailing-address">
                <TextField name="mailingAddress" label="Mailing Address" required={true} />
                <TextField name="mailingAddress2" label="Mailing Address 2" required={false} />
                <TextField name="mailingCity" label="Mailing City" required={true}/>
                <SelectField options={usStates} required={true} name="mailingState" placeholder="State" labelType="bold" label="Select Your Mailing State"
                            />
                <NumberField name="mailingZipcode" pattern={zipRegex} format="#####" label="Mailing ZIP Code" required={true}/>
            </div>
        )
    }
}

export default StepContactInfo;